var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-slider slider mb-5"},[_c('div',{},[_c('img',{staticClass:"img-fluid",attrs:{"src":((_vm.$root.image_url_c) + "inside/1350x320/" + (_vm.item.image))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }